import React from 'react';
import { bool, func, string } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { WishlistBtn, HeaderEl, MagaluIndica } from './card-header.styles';
import { SponsoredEl } from '../product-card.styles';
import { GALLERY, MINIATURE } from '../../../constants';

const CardHeader = ({
  displayMode,
  sponsored,
  showWishBtn,
  isLiked,
  handleAddToWishlist,
  isMagaluIndica,
  isMercadoFull
}) => /*#__PURE__*/React.createElement(HeaderEl, {
  isMagaluIndica: isMagaluIndica || isMercadoFull,
  displayMode: displayMode,
  sponsored: sponsored
}, sponsored && displayMode === MINIATURE && /*#__PURE__*/React.createElement(SponsoredEl, {
  place: "header"
}, "Patrocinado"), (isMagaluIndica || isMercadoFull) && displayMode === GALLERY && /*#__PURE__*/React.createElement(MagaluIndica, {
  autoSize: true,
  padding: "2px 8px",
  bg: "primary",
  fontSize: 1,
  startIcon: isMagaluIndica ? /*#__PURE__*/React.createElement(Icon, {
    name: "FastDelivery",
    fill: "#fff",
    width: "16px",
    height: "16px"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "FastMarket",
    fill: "#fff",
    width: "16px",
    height: "16px"
  }),
  fontWeight: "bold",
  gridGap: 1,
  minWidth: "unset",
  borderRadius: 6
}, isMagaluIndica ? 'Full' : 'Mercado Full'), showWishBtn && /*#__PURE__*/React.createElement(WishlistBtn, {
  active: isLiked,
  onClick: handleAddToWishlist
}));

process.env.NODE_ENV !== "production" ? CardHeader.propTypes = {
  displayMode: string,
  sponsored: bool,
  showWishBtn: bool,
  isLiked: bool,
  handleAddToWishlist: func,
  isMagaluIndica: bool,
  isMercadoFull: bool
} : void 0;
export default CardHeader;